/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Mx_Models_StdInputs */

const en_mk_mx_models_std = /** @type {(inputs: Mk_Mx_Models_StdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standard models (fast, cheap)`)
};

const id_mk_mx_models_std = /** @type {(inputs: Mk_Mx_Models_StdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Model standar (cepat, murah)`)
};

/**
* | output |
* | --- |
* | "Standard models (fast, cheap)" |
*
* @param {Mk_Mx_Models_StdInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_mx_models_std = /** @type {((inputs?: Mk_Mx_Models_StdInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Mx_Models_StdInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_mx_models_std(inputs)
	return en_mk_mx_models_std(inputs)
});